import { AICoreService } from './aiCoreService'
import { AIChatService } from './aiChatService'
import { AIRatingsService } from './aiRatingsService'
import { AIMediaService } from './aiMediaService'
import { AICleanupService } from './aiCleanupService'

/**
 * Backward-compatible facade that delegates to feature-specific AI services.
 * All 12+ consumer files can keep importing { AIService } with zero changes.
 *
 * For new code, prefer importing from the specific service directly:
 *   import { AICoreService } from '../services/ai/aiCoreService'
 *   import { AIMediaService } from '../services/ai/aiMediaService'
 */
export class AIService {
  // --- Core Ideation Pipeline (aiCoreService) ---
  static processNode = AICoreService.processNode
  static classifyBranchType = AICoreService.classifyBranchType
  static generateIdeas = AICoreService.generateIdeas
  static generateNeedsFromVenture = AICoreService.generateNeedsFromVenture
  static synthesizeNeedsFromResearch = AICoreService.synthesizeNeedsFromResearch

  // --- Chat (aiChatService) ---
  static sendChatMessage = AIChatService.sendChatMessage

  // --- Ratings & Phase (aiRatingsService) ---
  static generateRatings = AIRatingsService.generateRatings
  static assignPhase = AIRatingsService.assignPhase

  // --- Media Generation (aiMediaService) ---
  static generateStoryboard = AIMediaService.generateStoryboard
  static generateStoryboardDescriptions = AIMediaService.generateStoryboardDescriptions

  // --- Cleanup (aiCleanupService) ---
  static deleteImages = AICleanupService.deleteImages
}
